import {useState} from 'react';
import {Select} from 'antd';
import {Flower1RoomId, Flower2RoomId, Flower3RoomId, Flower4RoomId,
    Harvest1RoomId, Harvest2RoomId} from "../../api/RoomConstants";

export const RoomSelectWidget = ({roomId, roomMap, type, onSelect, placeholder="Room", io}) => {
    const [active, setActive] = useState(false);

    const onClick = () => {
        setActive(true);
    }

    const onBlur = () => {
        setActive(false);
    }

    const onRoomSelect = (value) => {
        if (onSelect) {
            onSelect(value);
        }
        setActive(false);
    }

    if ((roomMap === undefined) || (Object.keys(roomMap).length === 0)) {
        return <div />
    }

    const roomName = roomId ? roomMap[roomId].name : "None"

    let options;
    if (type === "flower") {
        options = [
            {
                label: roomMap[Flower1RoomId].name,
                value: roomMap[Flower1RoomId],
                key: Flower1RoomId,
            },
            {
                label: roomMap[Flower2RoomId].name,
                value: roomMap[Flower2RoomId],
                key: Flower2RoomId,
            },
            {
                label: roomMap[Flower3RoomId].name,
                value: roomMap[Flower3RoomId],
                key: Flower3RoomId,
            },
            {
                label: roomMap[Flower4RoomId].name,
                value: roomMap[Flower4RoomId],
                key: Flower4RoomId,
            },
        ]
    } else if (type === "harvest") {
        options = [
            {
                label: roomMap[Harvest1RoomId].name,
                value: roomMap[Harvest1RoomId],
                key: Harvest1RoomId,
            },
            {
                label: roomMap[Harvest2RoomId].name,
                value: roomMap[Harvest2RoomId],
                key: Harvest2RoomId,
            },
        ]
    }


    if (active) {
        return <Select options={options} onSelect={onRoomSelect} popupMatchSelectWidth={false} placeholder={placeholder} onBlur={onBlur} />
    } else {
        return <div style={{marginTop: '5px', cursor: 'pointer', color: "#108ee9"}} onClick={onClick}>
            {roomName}
        </div>
    }
}